import React from 'react';

type SeparatorProps = {
  height: number;
};

export const Separator = ({ height }: SeparatorProps) => {
  return <div style={{ height }} />;
};
